import React, { useState, useEffect } from 'react';
import StoryEditor from './StoryEditor';
import StoryLibrary from './StoryLibrary';
import PublicStoryLibrary from './PublicStoryLibrary';
import OurLibrary from './OurLibrary';
import ScheduleManager from './ScheduleManager';
import '../App.css';

function MainPage() {
    const [stories, setStories] = useState([]);
    const [gallery, setGallery] = useState([]);

    const [showOur, setShowOur] = useState(false);
    const [showSchedules, setShowSchedules] = useState(false);
    const [ourAllowUpload, setOurAllowUpload] = useState(true);
    const [publicStory, setPublic] = useState(0);
    const [privateStory, setPrivate] = useState(1);

    function goToPublicView() {
        setPublic(1);
        setPrivate(0);
    }

    function goToPrivateView() {
        setPrivate(1);
        setPublic(0);
    }

    useEffect(() => {
        fetch('https://storypublisher.onrender.com/stories')
            .then(res => res.json())
            .then(data => setStories(data));

        const handler = (e) => {
          console.log('MainPage received openOurLibrary event, detail:', e.detail);
          const allow = e.detail && e.detail.allowUpload === true;
          setOurAllowUpload(allow);
          setShowOur(true);
        };
        window.addEventListener('openOurLibrary', handler);
        return () => window.removeEventListener('openOurLibrary', handler);

    }, []);

    useEffect(() => {
        fetch('https://storypublisher.onrender.com/gallery')
            .then(res => res.json())
            .then(data => setGallery(data));

        const handler = (e) => {
          console.log('MainPage received openOurLibrary event, detail:', e.detail);
          const allow = e.detail && e.detail.allowUpload === true;
          setOurAllowUpload(allow);
          setShowOur(true);
        };
        window.addEventListener('openOurLibrary', handler);
        return () => window.removeEventListener('openOurLibrary', handler);

    }, []);

    const addStory = async (newStory) => {
        // If story already looks saved by the server (has _id or id), just prepend it and avoid re-posting
        if (newStory && (newStory._id || newStory.id)) {
            setStories(prev => [newStory, ...prev]);
            return;
        }
        const res = await fetch('https://storypublisher.onrender.com/stories', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newStory)
        });
        const savedStory = await res.json();
        setStories(prev => [savedStory, ...prev]);
    };

    const addToGallery = async (newPhoto) => {
        // If story already looks saved by the server (has _id or id), just prepend it and avoid re-posting
        if (newPhoto && (newPhoto._id || newPhoto.id)) {
            setGallery(prev => [newPhoto, ...prev]);
            return;
        }
        const res = await fetch('https://storypublisher.onrender.com/gallery', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newPhoto)
        });
        const savedPhoto = await res.json();
        setGallery(prev => [savedPhoto, ...prev]);
    };

    const clearAll = async () => {
        const deleteStories = prompt('ARE YOU SURE YOU WANT TO DELETE ALL? Y or N')
        if (deleteStories === 'Y') {
            await fetch('https://storypublisher.onrender.com/stories', { method: 'DELETE' });
            setStories([]);
        } else{
            return null;
        }

    };

    const deleteStory = async (id) => {
        await fetch(`https://storypublisher.onrender.com/stories/${id}`, { method: 'DELETE' });
        setStories(prev => prev.filter(story => story._id !== id));
    };

    const editStory = async (id, updatedData) => {
        const res = await fetch(`https://storypublisher.onrender.com/stories/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedData)
        });
        const updated = await res.json();
        setStories(prev =>
            prev.map(story => (story._id === id ? updated : story))
        );
    };



    return (
        <div className="App">
            {showSchedules ? (
                <>
                    <div className="button-group">
                        <button onClick={() => setShowSchedules(false)}>Back to Stories</button>
                    </div>
                    <ScheduleManager />
                </>
            ) : showOur ? (
                <>
                    <div className="button-group">
                        <button onClick={() => setShowOur(false)}>Back</button>
                    </div>
                    <OurLibrary stories={gallery} addStory={addToGallery} allowUpload={ourAllowUpload} />
                </>
            ) : (
            <>
                {privateStory ? (
                    <>
                        <h1>For Her</h1>
                        <div className="button-group">
                            <button onClick={clearAll} >Clear All</button>
                            <button onClick={goToPublicView}>Public View</button>
                            <button onClick={() => { setOurAllowUpload(true); setShowOur(true); }}>Our Gallery</button>
                            <button onClick={() => setShowSchedules(true)}>📅 Manage Schedules</button>
                        </div>
                        <StoryEditor addStory={addStory} />
                        <StoryLibrary stories={stories} onDelete={deleteStory} onEdit={editStory} />
                    </>
                ) : null}

                {(publicStory ? (
                    <>
                        <h1>For Her</h1>
                        <div className="button-group">
                            <button onClick={goToPrivateView}>Private View</button>
                            <button onClick={() => { setOurAllowUpload(false); setShowOur(true); }}>Our Gallery</button>
                        </div>
                        <PublicStoryLibrary stories={stories} onOpenOur={() => { console.log('MainPage onOpenOur called'); setOurAllowUpload(false); setShowOur(true); }} />
                    </>
                ) : null)}
            </>
            )}
        </div>


    );
}

export default MainPage;
